// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html {\n    height: 100vh;\n}\n\nbody {\n    box-sizing: border-box;\n    font-size: 1.6rem;\n    height: 100%;\n    margin: 0;\n    overflow: hidden;\n    padding: 0;\n}\n\ntextarea {\n    font-family: inherit;\n    font-size: inherit;\n }\n", ""]);
// Exports
module.exports = exports;
